<div class="display-message">
    <i class="icon-properties fa-regular fa-folder-magnifying-glass"></i>
    <span>Ihr Ergebnis wird hier angezeigt.</span>
</div>